if (typeof TermsAndConditionsToggle !== 'function') {

  class TermsAndConditionsToggle extends HTMLElement {
    constructor() {
      super();

      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.checkoutButton = this.getCheckoutButton();

      if (!this.checkbox || !this.checkoutButton) {
        return;
      }

      this.checkbox.addEventListener('change', () => this.toggleCheckoutButton());

      this.toggleCheckoutButton();
    }

    getCheckoutButton() {
      const targetId = this.getAttribute('data-checkout-button');
      if (targetId) {
        const button = document.getElementById(targetId);
        if (button) {
          return button;
        }
      }

      const scopes = [
        this.closest('.cart__details'),
        this.closest('.sidebar__footer'),
        this.closest('form'),
        this.closest('sidebar-drawer'),
        document
      ];

      for (const scope of scopes) {
        if (!scope) {
          continue;
        }
        const button = scope.querySelector('button[name="checkout"]');
        if (button) {
          return button;
        }
      }

      return null;
    }

    toggleCheckoutButton() {
      const shouldDisable = !this.checkbox.checked;

      if ('disabled' in this.checkoutButton) {
        this.checkoutButton.disabled = shouldDisable;
      }

      if (shouldDisable) {
        this.checkoutButton.setAttribute('aria-disabled', 'true');
      } else {
        this.checkoutButton.removeAttribute('aria-disabled');
      }

      this.checkoutButton.classList.toggle('button--terms-disabled', shouldDisable);
    }
  }

  if (typeof customElements.get('terms-checkbox') === 'undefined') {
    customElements.define('terms-checkbox', TermsAndConditionsToggle);
  }

}
